module.exports = __webpack_public_path__ + "img/doc-rejected.2ac4123b.svg";